// extracted by mini-css-extract-plugin
module.exports = {"price":"common-tips_price_qLq0K","bless":"common-tips_bless_aqtDW"};